import React from 'react';
import { Button as AntdButton } from 'antd';
import { ButtonProps as AntdButtonProps } from 'antd/lib/button/button';

export interface ButtonProps extends AntdButtonProps {
  eventName?: string;
  logEventData?: Object;
}

const Button = ({
  onClick: originalOnClick,
  logEventData,
  ...props
}: ButtonProps) => {
  const [isLoading, setIsLoading] = React.useState(false);

  return (
    <AntdButton
      loading={isLoading}
      {...props}
      onClick={(...args) => {
        if (originalOnClick) {
          setIsLoading(true);
          Promise.resolve(originalOnClick(...args)).finally(() =>
            setIsLoading(false),
          );
        }
      }}
    />
  );
};

export default Button;
